module.exports = __webpack_public_path__ + "img/Headshot.9bc1dffd.jpg";